<template>
    <section id="footer">
        <div class="social-icons">
            <a class="social-icon" href="mailto:anithuha@gmail.com">
                <img src="../assets/svg/email.svg" alt="Email" />
            </a>
            <a class="social-icon" target="_new" href="https://instagram.com/anita_kucharczyk">
                <img src="../assets/svg/insta.svg" alt="Instagram" />
            </a>
            <a class="social-icon" target="_new" href="https://www.linkedin.com/in/anita-kucharczyk/">
                <img src="../assets/svg/linkedin.svg" alt="LinkedIn" />
            </a>
        </div>
        <p>&copy; {{ new Date().getFullYear() }} Anita Kucharczyk. All Rights Reserved</p>
    </section>
</template>

<script>

</script>

<style lang="scss" scoped>
    #footer {
        .social-icons {
            display: flex;
            justify-content: center;
            .social-icon {
                padding: 8px;
                transform: scale(1);
                transition: 0.5s all;
                
                img {
                    width: 32px;
                    height: 32px;
                }
            }
            .social-icon:hover {
                transform: scale(1.2);
                transition: 0.3s all;
            }
            .social-icon:active {
                transform: scale(0.9);
                transition: 0.2s all;
            }
        }
        p {
            padding-top: 16px;
            padding-bottom: 32px;
            font-family: $Thin;
            text-align: center;
            font-size: 20px;
        }
    }
    @media screen and (max-width: $breakpoint-md) {
        #footer {
            .social-icons {
                .social-icon {
                    padding: 14px;
                }
            }
            p {
                font-size: 14px;
            }
        }
    }
</style>